module.exports = __webpack_public_path__ + "static/img/img42.3312c22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img42.png
// module id = OQue
// module chunks = 1